export default {
  BA: 'BA',
  CA: 'CA',
  BENSENVILLE_CODE: 'BENS',
  API_ERR_MESSAGE: 'An unexpected error has occurred, please refresh and try again...',
};
